// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64.99 58.89\"><defs><style>.a417aaea-b2c2-4057-a446-5c8d54fd2e69{fill:#fdcb47}</style></defs><g id=\"b1ce01be-35e8-4a2d-9ee1-1926fc46afe7\" data-name=\"Layer 2\"><g id=\"bad854ad-1374-4f1d-9169-5f473740cf06\" data-name=\"Layer 1\"><path class=\"a417aaea-b2c2-4057-a446-5c8d54fd2e69\" d=\"M8.5,58.89h48a8.49,8.49,0,0,0,7.36-12.71l-24-41.91a8.49,8.49,0,0,0-14.73,0l-24,41.91A8.5,8.5,0,0,0,8.5,58.89Z\"/><path d=\"M29.73,49.44a3.89,3.89,0,0,1,0-5.36,3.71,3.71,0,0,1,2.74-1,3.81,3.81,0,0,1,2.77,1,3.84,3.84,0,0,1,0,5.36,3.85,3.85,0,0,1-2.77,1A3.75,3.75,0,0,1,29.73,49.44ZM29,27.27V18.41h7v8.86L34.2,39.45H30.79Z\"/></g></g></svg>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader/dist/cjs.js!./src/assets/icons/icon-warning.svg
// module id = 67lQ
// module chunks = 32